import { setKissmetricsAliasing } from '../kissmetrics'
import { Mixpanel } from '../mixpanel'

import { setChurnZeroContact } from './churn-zero'
import { setProfitwell } from './profitwell'

export const setUserForTracking = ({
  email,
  id,
}: {
  email: string
  id: string
}) => {
  Mixpanel.identify(email)
  setKissmetricsAliasing(email)
  setProfitwell(email)
  setChurnZeroContact({ email, id })
}
